import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAccionesLiquidaciones } from '../../../../actions/LiquidacionesActions';
import { postNuevaNovedadConcepto } from '../../../../api/axios';
import { DropDownArrow, customStyleFilter, filterSelectMenuPortalProps } from '../../../../template/CustomStyle';
import { toast } from '../../../../utilities/appToast';
import Select from 'react-select';
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import { LiquidacionesBtnGuardar, LiquidacionesBtnCancelar } from '../../shared/LiquidacionesButtons';

// Wrapper para usar hooks en class component
function ConceptoNewWrapper(props) {
  const navigate = useNavigate();
  return <ConceptoNew {...props} navigate={navigate} />;
}

class ConceptoNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comboLiquidacionAcciones: { label: "", value: "" },
            request: null
        };
        this.nombreInputRef = React.createRef();
    };

    componentDidMount() {
        this.props.fetchAccionesLiquidaciones();

        if (this.nombreInputRef.current) {
            this.nombreInputRef.current.focus();
        }
    }

    regresar = () => {
        this.props.navigate("/Conceptos");
    }

    selectSearchHandlerLiquidacionesAcciones = (options) => {
        let valor = { label: options ? options.label : "", value: options ? options.value.toString() : "" };
        this.setState({
            comboLiquidacionAcciones: valor
        })
    }

    onSubmit = async (event) => {
        event.preventDefault();

        const nombre = document.getElementById("NuevaNovedadNombre").value;
        const accionSeleccionadaValue = this.state.comboLiquidacionAcciones.value;

        if (nombre === "") {
            toast.warn("Debe agregar un nombre ");
            return;
        }

        if (!accionSeleccionadaValue) {
            toast.warn("Debe seleccionar una acción");
            return;
        }

        //me traigo el valor idSubTipo
        let idSubTipo = parseInt(accionSeleccionadaValue, 10);

        //busco dentro del array si coincide id=idSubTipo
        let accionSeleccionada = this.props.lista_acciones_liquidaciones.find(accion => accion.idEstado === idSubTipo);

        //busco la descripción 
        let descripcionAccion = accionSeleccionada ? accionSeleccionada.descripcion : "";

        let data = {
            concepto: nombre,
            idSubTipo: idSubTipo,
            descripcionSubTipo: descripcionAccion,
            //idTipoNovedad:
            mostrarBotonEliminar: true
        };

        let post = postNuevaNovedadConcepto(data);

        post.then(res => {
            toast.success("El concepto de la novedad fue creada con éxito");
            document.getElementById("NuevaNovedadNombre").value = "";
            document.getElementById("NuevaNovedadNombre").focus();
            return;
        }).catch (err => {
                const errores = err?.response?.data?.errores;
                if (Array.isArray(errores))
                    errores.forEach(error => toast.error(error.item2));
                else
                    toast.error("No pudimos crear el concepto de novedad");
        });
    }


    render() {

        let listaAccionesLiquidacion = [];
        if (this.props.lista_acciones_liquidaciones != undefined) {
            this.props.lista_acciones_liquidaciones.map((tipo) => {
                listaAccionesLiquidacion.push({ label: tipo.descripcion, value: tipo.idEstado })
            })
        };

        let selectListaAcciones = 
        <div>
            <label className="form-label small text-muted mb-1">Acción</label>
            <Select
                name="NuevaLiquidacionAcciones"
                id="NuevaLiquidacionAcciones"
                value={this.state.comboLiquidacionAcciones}
                options={listaAccionesLiquidacion}
                onChange={this.selectSearchHandlerLiquidacionesAcciones}
                styles={customStyleFilter}
                {...filterSelectMenuPortalProps}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>


        return (
            <form className="container gestion-liquidaciones liquidaciones-modulo pb-4" onSubmit={this.onSubmit}>
                <LiquidacionesPageHeader
                    title="Crear concepto"
                    subtitle="Definí un nuevo concepto de liquidación y asociále una acción."
                    onBack={this.regresar}
                    backLabel="Volver"
                    showBack
                />

                <div className="liquidaciones-form-card">
                    <div className="liquidaciones-form-card__header d-flex align-items-center justify-content-between flex-wrap gap-2">
                        <span className="liquidaciones-form-card__header-title">Datos principales</span>
                        <span className="text-muted small mb-0 d-none d-md-inline">Completá nombre y acción antes de guardar</span>
                    </div>

                    <div className="liquidaciones-form-card__body">
                        <div className="row align-items-end g-3">
                            <div className="col-12 col-md-6 col-lg-5">
                                <label htmlFor="NuevaNovedadNombre" className="form-label small text-muted mb-1">Nombre</label>
                                <input 
                                    type="text" 
                                    name="NuevaNovedadNombre" 
                                    id="NuevaNovedadNombre" 
                                    className="form-control"
                                    placeholder="Ej.: Reintegro por campaña"
                                    ref={this.nombreInputRef}
                                />
                            </div>

                            <div className="col-12 col-md-6 col-lg-4">
                            {
                                this.props.tipoUsuario !== 2 ? 
                                selectListaAcciones : selectListaAcciones
                            }
                            </div>

                            <div className="col-12 col-lg-3">
                                <div className="d-flex flex-column flex-sm-row justify-content-lg-end gap-2">
                                    <LiquidacionesBtnGuardar type="submit">
                                        Confirmar
                                    </LiquidacionesBtnGuardar>

                                    <LiquidacionesBtnCancelar onClick={this.regresar}>
                                        Cancelar
                                    </LiquidacionesBtnCancelar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => ({
    lista_acciones_liquidaciones: state.liquidaciones.lista_acciones_liquidaciones,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { fetchAccionesLiquidaciones }) (ConceptoNewWrapper);